import { render, staticRenderFns } from "./AreaManagerTeaser.vue?vue&type=template&id=773b509a"
import script from "./AreaManagerTeaser.vue?vue&type=script&lang=js"
export * from "./AreaManagerTeaser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports